// extracted by mini-css-extract-plugin
module.exports = {"marquee":"Marquee_marquee__3EMqg","marqueeInner":"Marquee_marqueeInner__3aWJf"};